import { render, staticRenderFns } from "./NewDUeditorEditor.vue?vue&type=template&id=55f06066&"
import script from "./NewDUeditorEditor.vue?vue&type=script&lang=js&"
export * from "./NewDUeditorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports